import { Injectable } from '@angular/core';

import { ModalDialogService } from '../../_shared/services/modal-dialog.service';
import { UtilService } from '../../_shared/services/util.service';

import { WhatToBring } from './what-to-bring.model';
import { WhatToBringsModalComponent } from '../components/what-to-brings-modal/what-to-brings-modal.component';
import { WhatToBringModalComponent } from '../components/what-to-bring-modal/what-to-bring-modal.component';
import { WhatToBringTranslationModalComponent } from '../components/what-to-bring-translation-modal/what-to-bring-translation-modal.component';

@Injectable({
  providedIn: 'root',
})
export class WhatToBringModalService {
  constructor(private modalDialogService: ModalDialogService, private utilService: UtilService) {}

  openWhatToBringsModal(successCallback) {
    const options = {
      width: '700px', // 1000px
      minHeight: '80vh',
      maxHeight: '80vh',
      position: { top: '5vh' },
      disableClose: true,
      data: {
        title: 'WHAT_TO_BRING',
      },
      confirmCallback: successCallback,
    };

    this.modalDialogService.open(options, WhatToBringsModalComponent);
  }

  openWhatToBringModal(
    whatToBrings: WhatToBring,
    defaultLanguage,
    additionalLanguages,
    mode,
    successCallback = null
  ) {
    const confirmCallback = (result) => {
      // Edit
      if (whatToBrings.id) {
        whatToBrings.name = result.name;
        whatToBrings.description = result.description;
        whatToBrings.type = result.type;

        return this.utilService.changeItemRowStyle(whatToBrings.id);
      }

      return successCallback(result);
    };

    const options = {
      disableClose: true,
      data: {
        title: 'WHAT_TO_BRING_DETAILS',
        obj: whatToBrings,
        params: {
          defaultLanguage: defaultLanguage,
          additionalLanguages: additionalLanguages,
          mode: mode,
        },
      },
      confirmCallback: confirmCallback,
    };

    this.modalDialogService.open(options, WhatToBringModalComponent);
  }

  openWhatToBringTranslation(whatToBrings: WhatToBring, language: any) {
    const options = {
      panelClass: 'dialog-sidepanel',
      position: { right: '0' },
      data: {
        title: 'WHAT_TO_BRING_DETAILS',
        obj: whatToBrings,
        params: {
          language: language,
        },
      },
    };

    this.modalDialogService.open(options, WhatToBringTranslationModalComponent);
  }
}
